export default {
    signs: null,
    diagnoses: null,
}